
import { useState } from 'react';
import { BusinessData } from '@/api/business/types';

export const useBusinessStateManager = (
  initialBusinessData: BusinessData,
  setBusinessData: (data: BusinessData) => void
) => {
  const [isDirty, setIsDirty] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  
  // Update a single field
  const updateBusinessData = (
    key: string, 
    value: string | string[] | number | Record<string, string>
  ) => {
    // Create a new object with the updated field
    const updatedData = {
      ...initialBusinessData,
      [key]: value
    };
    
    // Update the business data
    setBusinessData(updatedData);
    setIsDirty(true);
    
    // Log the update for debugging purposes
    console.log(`Updated business data field: ${key}`, value);
  };
  
  // Update multiple fields at once
  const updateMultipleFields = (
    updates: Record<string, string | string[] | number | Record<string, string>>
  ) => {
    // Create a new object with all updated fields
    const updatedData = {
      ...initialBusinessData,
      ...updates
    };
    
    // Update the business data
    setBusinessData(updatedData);
    setIsDirty(true);
    
    // Log the updates for debugging purposes
    console.log('Updated multiple business data fields:', updates);
  };
  
  return {
    isDirty,
    setIsDirty,
    isSaving,
    setIsSaving,
    updateBusinessData,
    updateMultipleFields
  };
};
